import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'agroline.sidebar.collapsed'

const readInitial = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * Persisted collapsed state for the desktop sidebar. Defaults to expanded;
 * the user's last choice is restored from localStorage on next visit.
 */
export const useSidebarCollapsed = (): [boolean, () => void] => {
  const [collapsed, setCollapsed] = useState<boolean>(readInitial)

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
    } catch {
      /* localStorage unavailable (private mode etc.) — ignore. */
    }
  }, [collapsed])

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [])

  return [collapsed, toggle]
}

export default useSidebarCollapsed
